__turbopack_context__.v({
  "button": "SearchButton-module__ziQQWW__button",
  "buttonContent": "SearchButton-module__ziQQWW__buttonContent",
  "content": "SearchButton-module__ziQQWW__content",
  "hidden": "SearchButton-module__ziQQWW__hidden",
  "icon": "SearchButton-module__ziQQWW__icon",
  "kbd": "SearchButton-module__ziQQWW__kbd",
  "kbdCmd": "SearchButton-module__ziQQWW__kbdCmd",
  "shortcut": "SearchButton-module__ziQQWW__shortcut",
  "text": "SearchButton-module__ziQQWW__text",
  "wrapper": "SearchButton-module__ziQQWW__wrapper",
});
